// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__3ypex","inputWrap":"Table_inputWrap__3BGJ4","col":"Table_col__1oVqp","bmiTooltip":"Table_bmiTooltip__BK9s3"};